export const fuelTypes = {
	gasoline: 'Bensin',
	E10: 'E10',
	E5: 'E5',
	'natural gas': 'Naturgass',
	ethane: 'Etan',
	butane: 'Butan',
	CNG: 'CNG',
	diesel: 'Diesel',
	LNG: 'LNG',
	LPG: 'LPG',
	'petroleum gas': 'Petroleumsgass',
	propane: 'Propan',
	wood: 'Ved',
	naphtha: 'Nafta',
	coal: 'Kull',
	'coking coal': 'Koksingskull',
	'petroleum coke': 'Petroleumskoks',
}
